<template>
        <div id="app">
            <div class="app-content container-fluid mt-4">

                <div class="desc" v-html="headerText">
                </div>

                <!-- PAY -->
                <div class="border-section shadow m-2 p-4 income-cnt">
                    <div class="row">
                        <h2 class="col-md-8">Pajamos</h2>
                        <svg class="tax-distr-chart col-md" id="income_svg" height="0" ></svg>
                    </div>
                    <div class="row align-items-start mb-2">
                        <div class="col-md-8">
                            <div class="form-group row">
                                <label class="col col-form-label">atlyginimas popieriuje</label>
                                <div class="col">
                                    <input type="number" class="form-control" @input="onBeforetaxChange" v-model.number="income.beforetax">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col col-form-label">atlyginimas į rankas</label>
                                <div class="col">
                                    <input type="number" class="form-control" @input="onAftertaxChange" v-model.number="income.aftertax">
                                </div>
                            </div>
                        </div>
                        <p class="col-md desc" v-html="incomeText">
                        </p>
                    </div>
                </div>

                <!-- EXPENSES -->
                <div class="border-section shadow m-2 p-4 expenses-cnt">
                    <h2>Išlaidos</h2>
                    <svg :hidden="true" class="tax-distr-chart m-1" id="expenses_total_svg" height="0"></svg>
                    <div v-for="(g, group_key) in expensesGroups" class="pt-4 border-top expensegroup" :key="group_key">
                        <div class="row">
                            <h3 class="col-md-8"><span v-if="g.icon"><font-awesome-icon class="icon" :icon="g.icon"></font-awesome-icon></span>&nbsp;&nbsp;{{g.name}}</h3>
                            <svg class="col-md tax-distr-chart" :id="group_key + '_svg'" height="0"></svg>
                        </div>
                        <div class="row align-items-start mb-2">
                            <div class="col-md-8">
                                <div class="row mb-1" v-for="(i, item_key) in g.items" :key="item_key">
                                    <label class="col col-form-label">{{i.label}}</label>
                                    <div class="col" v-if="!expenseNeedsCountInput(i)">
                                        <input type="number" v-model.number="i['value']" class="form-control" @input="onExpenseItemChangeValue(i)">
                                    </div>
                                    <div class="col form-group" v-if="expenseNeedsCountInput(i)">
                                        <label>vertė</label>
                                        <input type="number" v-model.number="i['value']" class="form-control" @input="onExpenseItemChangeValue(i)">
                                    </div>
                                    <div class="col form-group" v-if="expenseNeedsCountInput(i)">
                                        <label>kiekis</label>
                                        <input type="number" v-model.number="i['count']" class="form-control" @input="onExpenseItemChangeCount(i)">
                                        <small class="form-text text-muted">{{i.countLabel}}</small>
                                    </div>
                                </div>
                            </div>
                            <p class="col-md desc">
                            <span v-if="expensesTextData[group_key]">{{g.name_d}} sumokate mokesčius, kurie sudaro <span class="tax">{{expensesTextData[group_key].tax}}</span>.
                                <span v-if="expensesTextData[group_key].exciseProportion">
                                    Mokesčių dalyje akcizas sudaro <span class="tax">{{expensesTextData[group_key].excise}}.</span>
                                </span>
                                <br>
                            </span>
                            {{g.desc}}
                            </p>
                        </div>
                    </div>
                </div>
                
                <!-- GOVT USE -->
                <div class="border-section shadow m-2 p-4 govtuse-cnt">
                    <h2 >Sumokėtų mokesčių paskirstymas valstybės funkcijoms</h2>
                    <div class="desc mb-4" v-html="taxuseHeaderText">
                    </div>
                    <div v-for="g in govtUseData" class="pt-1 pb-1 govtuse border-top" :key="g.code">
                        <div class="row">
                            <h4 class="col-md-4 d-flex">
                                <font-awesome-icon class="icon" :icon="g.icon"></font-awesome-icon>
                                <span class="govtuse-label">&nbsp;&nbsp;{{g.label}}</span>
                            </h4>
                            <h4 class="col-md-2 govtuse-value">&nbsp;{{formatEuro(g.value)}}</h4>
                            <svg class="col-md tax-distr-chart" :id="g.code + '_svg'" height="0"></svg>
                            <div class="col-md d-flex justify-content-end">
                                <a @click.prevent="onGovtUserExpandToggle(g)" data-toggle="collapse" :href="'#collapse_' + g.code"><font-awesome-icon class="icon" :icon="govtUseExpandIcon(g)"></font-awesome-icon></a>
                            </div>
                        </div>
                        <div class="collapse" :id="'collapse_' + g.code">
                            <div class="card card-body">
                                <p v-if="g.text" class="desc" v-html="g.text"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TOTALS -->
                <div class="m-2 p-4 text-center">
                    <div class="row justify-content-center">
                        <div class="shadow col-4 col-md-3 mr-2 ml-2 pt-2 pb-2 kpi-box" v-for="kpiBox in taxKPIBoxes" :key="kpiBox.name">
                            <h4 class="kpi-title">{{kpiBox.name}}</h4>
                            <div class="kpi-value pr-4 pl-4">{{kpiBox.value}}</div>
                        </div>
                    </div>
                </div>



                    <!--div class="row">
                        <h2 class="col-md-4">Viso mokesčių: </h2>
                        <h2 class="col-md-2 govtuse-total-value">{{formatEuro(taxKPIData.total)}}</h2>
                    </div>
                    <div class="row">
                        <h4 class="col-md-4">Pajamų mokesčių: </h4>
                        <h4 class="col-md-2 govtuse-total-value">{{formatEuro(taxKPIData.income)}}</h4>
                    </div>
                    <div class="row">
                        <h4 class="col-md-4">Išlaidų mokesčių: </h4>
                        <h4 class="col-md-2 govtuse-total-value">{{formatEuro(taxKPIData.expenses)}}</h4>
                    </div-->

            </div>
        </div>
</template>

<script>

import * as d3 from "d3";
import barchartupdater from "./barchart";
import converters from "./converters";

export default {
    data: function() {
        return {
            defaultVat: 0.21,

            income: {
                beforetax: 0,
                aftertax: 0,
                showDetails: false
            },
            
            loaded: false,
            converters: {},
            avgPrice: {},
            govtTaxUseGroups: [],
            expensesGroups: {},
            headerText: '',
            taxuseHeaderText: '',
            incomeText: '',
            incomeTaxPartToUseGroupMap: null,

            govtUseExpandState: {}

        }
    },

    mounted: function() {
        var t = this;
        window.addEventListener('resize', function(){
            t.updateExpensesGroupsSvgs();
            t.updateIncomeSvg();
            t.updateGovtUseSvg();
        });
        this.loadData();
        this.converters = converters;
        this.converters.validateExternalFunctions();
    },

    methods: {
        onGovtUserExpandToggle: function(group) {
            var newState = {};
            newState[group.code] = !this.govtUseExpandState[group.code];
            this.govtUseExpandState = Object.assign({}, this.govtUseExpandState, newState);
        },
        govtUseExpandIcon: function(group) {
            return this.govtUseExpandState[group.code]? 'chevron-up' : 'chevron-down';
        },
        formatEuro: (function(){
            var formatter = new Intl.NumberFormat('lt-LT', {
                  style: 'currency',
                  currency: 'EUR',
            });
            return function(value) {
                return formatter.format(value);
            }
        })(),

        loadData: function() {
            var t = this;
            var r = new XMLHttpRequest();
            r.open("GET", "mokesciai_data.json", true);
            r.onreadystatechange = function () {
                if (r.readyState != 4 || r.status != 200) return;
                var resp = JSON.parse(r.responseText);
                t.avgPrice = resp.avgPrice;
                t.govtTaxUseGroups = resp.govtTaxUseGroups;
                t.expensesGroups = resp.expensesGroups;
                t.headerText = resp.headerText;
                t.taxuseHeaderText = resp.taxuseHeaderText;
                t.incomeText = resp.incomeText;
                t.incomeTaxPartToUseGroupMap = resp.incomeTaxPartToUseGroupMap;
                t.loaded = true;
            };
            r.send();
        },
        onAftertaxChange: function() {
            if (this.income.aftertax < 0)
                this.income.aftertax = 0;
            this.income.beforetax = Math.floor(this.converters.aftertaxToBeforetax(this.income.aftertax));
        },
        onBeforetaxChange: function() {
            if (this.income.beforetax < 0)
                this.income.beforetax = 0;
            this.income.aftertax = Math.floor(this.converters.beforetaxToAftertax(this.income.beforetax));
        },
        onExpenseItemChangeValue: function(item) {
            if (item.value < 0)
                item.value = 0;
        },
        onExpenseItemChangeCount: function(item) {
            if (item.count < 0)
                item.count = 0;
        },
        //returns [beforetax, tax]
        //beforetax + tax = item.value
        getExpensesDistributedForItem: function(item) {
            var val = item.value? item.value : 0;
            var count = item.count? item.count : 0;
            var vat = item.vat || this.defaultVat;
            var beforeVatVal = val / (1 + vat);
            if (item.avgPriceId) {
                count = val / this.avgPrice[item.avgPriceId];
            }
            var excise = 0;
            if (item.excise) {
                if (count) {
                    var excisePerItem = item.excise;
                    if (item.excisePerItemValue && count && val) {
                        var minExcisePerItemValue = item.minExcisePerItemValue? item.minExcisePerItemValue : 0;
                        excisePerItem = Math.max(minExcisePerItemValue, (beforeVatVal / count) * item.excisePerItemValue + excisePerItem);
                    }
                    excise += count * excisePerItem;
                }
            }
            var beforeTaxVal = beforeVatVal - excise;
            var tax = val - beforeTaxVal;
            var res = [beforeTaxVal, tax, excise];
            return res;
        },
        expenseNeedsCountInput: function(item) {
            return item.excise && !item.avgPriceId;
        },
        getExpensesDistributedForGroup: function(group) {
            var items = [];
            for (var k in group.items) {
                items.push(this.getExpensesDistributedForItem(group.items[k]));
            }
            return items.reduce(function(a, b){
                return [
                    a[0] + b[0],
                    a[1] + b[1],
                    a[2] + b[2]
                ];
            });
        },
        updateExpensesGroupsSvgs: function() {
            for (var g in this.expensesSvgData) {
                barchartupdater(g + '_svg', this.expensesSvgData[g], this.expensesMaxValue);
            }
            barchartupdater('expenses_total_svg', this.expensesTotalSvgData, this.expensesTotalSvgData[0].value + this.expensesTotalSvgData[1].value);
        },
        updateIncomeSvg: function() {
            barchartupdater('income_svg', this.incomeSvgData, this.workplaceCost);
        },
        updateGovtUseSvg: function() {
            var max = this.govtUseSvgDataMaxValue;
            this.govtUseSvgData.forEach(function(d){
                barchartupdater(d.code + '_svg', [d], max);
            });
        }
    },

    computed: {
        expensesData: function() {
            var data = {};
            for (var g in this.expensesGroups) {
                var group = this.expensesGroups[g];
                var aggrExpensesDistributed = this.getExpensesDistributedForGroup(group);
                data[g] = aggrExpensesDistributed;
            }
            return data;
        },
        expensesSvgData: function() {
            var svgData = {};
            for (var g in this.expensesData) {
                svgData[g] = [{
                    cls: 'expenses',
                    label: 'Vertė',
                    value: this.expensesData[g][0]
                }, {
                    cls: 'tax',
                    label: 'Mokesčiai',
                    value: this.expensesData[g][1]
                }];
            }
            return svgData;
        },
        expensesTextData: function() {
            var data = {};
            for (var g in this.expensesData) {
                if (this.expensesData[g][0] <= 0 || this.expensesData[g][1] <= 0) continue;
                var expense = this.expensesData[g][0] + this.expensesData[g][1];
                data[g] = {
                    expense: this.formatEuro(expense),
                    tax: this.formatEuro(this.expensesData[g][1]),
                    excise: this.formatEuro(this.expensesData[g][2])
                };
            }
            return data;
        },
        expensesMaxValue: function() {
            var max = 0;
            for (var k in this.expensesSvgData) {
                var val = this.expensesSvgData[k][0].value + this.expensesSvgData[k][1].value;
                if (val)
                    max = Math.max(max, val);
            }
            return max;
        },
        expensesTotal: function() {
            var t = this;
            var expensesTotal = this.allItems
                .map(function(item){
                    return t.getExpensesDistributedForItem(item);
                })
                .reduce(function(a, b){
                    return [
                        a[0] + b[0],
                        a[1] + b[1]
                    ];
                }, [0, 0]);
            return expensesTotal;
        },
        expensesTotalSvgData: function() {
            return [{
                cls: 'expenses',
                label: 'islaidos',
                value: this.expensesTotal[0]
            }, {
                cls: 'tax',
                label: 'Mokesciai',
                value: this.expensesTotal[1]
            }];
        },
        allItems: function() {
            var items = [];
            for (var g in this.expensesGroups) {
                for (var i in this.expensesGroups[g].items) {
                    items.push(this.expensesGroups[g].items[i]);
                }
            }
            return items;
        },
        workplaceCost: function() {
            if (!this.income.beforetax || !this.converters)
                return 0;
            return this.converters.beforetaxToWorkplacecost(this.income.beforetax)
            //return this.income.beforetax + this.employeeTax;
        },
        taxKPIData: function() {
            var d = {
                expenses: this.expensesTotal[1],
                income: this.workplaceCost - this.income.aftertax
            };
            d.total = d.expenses + d.income;
            return d;
        },
        totalTax: function(){
            return this.workplaceCost - this.income.aftertax + this.expensesTotal[1];
        },
        totalExpenseTaxByGroup: function() {
            if (!this.govtTaxUseGroups.length) return {};
            var specDis = {};
            var commonDistribution = 0;
            this.allItems
                .forEach(i => {
                    var itemDis = this.getExpensesDistributedForItem(i);
                    if (i.straightToSpendGroup) {
                        var spec = 0;
                        if (i.straightToSpendGroup.excise)
                            spec += i.straightToSpendGroup.excise * itemDis[2];
                        if (i.straightToSpendGroup.vat)
                            spec += i.straightToSpendGroup.vat * (itemDis[1] - itemDis[2]);
                        commonDistribution += itemDis[1] - spec;
                        var curr = specDis[i.straightToSpendGroup.group];
                        if (!curr)
                            curr = spec;
                        else curr += spec;
                        specDis[i.straightToSpendGroup.group] = curr;
                    } else {
                        commonDistribution += itemDis[1];
                    }
                });
            var groups = {};
            this.govtTaxUseGroups
                .forEach(group => {
                    var v = 0;
                    if (specDis[group.code])
                        v += specDis[group.code];
                    v += commonDistribution * group.fraction;
                    groups[group.code] = v;
                });
            return groups;
        },
        totalIncomeTaxByGroup: function() {
            if (!this.govtTaxUseGroups.length) return {};
            var inc = this.income.beforetax;
            var gpm = this.converters.beforeTaxToGPM(inc);
            var vsd = this.converters.beforeTaxToVSD(inc);
            var psd = this.converters.beforeTaxToPSD(inc);
            var dsd = this.converters.beforeTaxToDSD(inc);
            var commonDistribution = 0;
            var specDis = {};
            function add(key, value) {
                var curr = specDis[key]? specDis[key] : 0;
                specDis[key] = curr + value;
            }
            if (this.income.beforetax) {
                if (this.incomeTaxPartToUseGroupMap.gpm) {
                    add(this.incomeTaxPartToUseGroupMap.gpm, gpm);
                } else {
                    commonDistribution += gpm;
                }
                if (this.incomeTaxPartToUseGroupMap.vsd) {
                    add(this.incomeTaxPartToUseGroupMap.vsd, vsd);
                } else {
                    commonDistribution += vsd;
                }
                if (this.incomeTaxPartToUseGroupMap.psd) {
                    add(this.incomeTaxPartToUseGroupMap.psd, psd);
                } else {
                    commonDistribution += psd;
                }
                if (this.incomeTaxPartToUseGroupMap.dsd) {
                    add(this.incomeTaxPartToUseGroupMap.dsd, dsd);
                } else {
                    commonDistribution += dsd;
                }
            }
            var groups = {};
            this.govtTaxUseGroups
                .forEach(group => {
                    var v = 0;
                    if (specDis[group.code])
                        v += specDis[group.code];
                    v += commonDistribution * group.fraction;
                    groups[group.code] = v;
                });
            return groups;
        },
        totalTaxByGroup: function() {
            var income = this.totalIncomeTaxByGroup;
            var expense = this.totalExpenseTaxByGroup;
            var total = {};
            for (let k in income) {
                total[k] = income[k] + expense[k];
            }
            return total;
        },
        incomeSvgData: function() {
            return [{
                cls: 'income',
                label: 'Atlygis',
                value: this.income.aftertax
            }, {
                cls: 'tax',
                label: 'Mokesčiai',
                value: this.workplaceCost - this.income.aftertax
            }];
        },
        govtUseData: function() {
            return this.govtTaxUseGroups.map(g => {
                return Object.assign({}, g, {value: this.totalTaxByGroup[g.code]});
            });
        },
        govtUseSvgData: function() {
            return this.govtUseData.map(g => {
                return {
                    code: g.code,
                    cls: 'govtuse',
                    label: '',
                    value: g.value
                };
            });
        },
        govtUseSvgDataMaxValue: function() {
            return d3.max(this.govtUseSvgData, function(d) { return d.value; });
        },
        taxKPIBoxes: function() {
            return [{
                name: 'Viso mokesčių',
                value: this.formatEuro(this.taxKPIData.total)
            }, {
                name: 'Gautų pajamų mokesčiai',
                value: this.formatEuro(this.taxKPIData.income)
            }, {
                name: 'Patirtų išlaidų mokesčiai',
                value: this.formatEuro(this.taxKPIData.expenses)
            }];
        }
    },

    watch: {
        expensesSvgData: {
            handler: function() {
                this.updateExpensesGroupsSvgs();
            }
        },
        govtUseSvgData: {
            handler: function() {
                this.updateGovtUseSvg();
            }
        },
        incomeSvgData: {
            handler: function() {
                this.updateIncomeSvg();
            }
        }
    }
}
</script>

<style>
#app .app-header {
    background-color: #005980;
    padding: 22px 31px 16px 40px;
}

#app .app-header .app-title {
    color: #e6e6e6;
    font-size: 39px;
    font-weight: 400;

}

#app .col.col-form-label {
    font-size: initial;
    font-weight: initial;
}

.border-section {
    border-top: 3px solid #bbb;
}

svg {
    padding: 0 !important;
}

g.labels text {
    dominant-baseline: hanging;
}

g.label text {
    fill: gray;
}

/*INCOME*/

rect.income {
    fill: #7d2d45;
}

g.label.income line {
    stroke: #7d2d45;
}

/*TAX*/

rect.tax {
    fill: #808080;
}

span.tax {
    font-weight: bold;
    color: #949595;
}

g.label.tax line {
    stroke: #949595;
}

rect.expenses {
    fill: #014691;
}

span.expenses {
    font-weight: bold;
    color: #014691;
}

g.label.expenses line {
    stroke: #014691;
}

.expensegroup .icon {
    color: #014691;
}

/*GOVTUSE*/

.govtuse-cnt {
    background-color: #f5f5f5;
    color: rgba(0, 0, 0, 0.75);
}

.govtuse-total-value {
    color: #009de0;
}

rect.govtuse {
    fill: #009de0;
}

.govtuse .icon, .govtuse-value {
    color: #009de0;
}

.govtuse .icon {
    width: 64px;
}

.govtuse .govtuse-label {
    flex: 1;
}

.govtuse .row > * {
    margin: auto;
}

.govtuse .row {
    min-height: 60px;
}

.govtuse-value, .govtuse-total-value {
    text-align: right;
    font-weight: bold;
}

.desc {
    color: gray;
}

/*TAX KPI*/
.kpi-box {
    background-color: #f5f5f5;
    color: rgba(0, 0, 0, 0.55);
    border-top: 2px solid #bbb;
}

.kpi-box:first-child {
    background-color: #014691;
    color: #f5f5f5;
    border-top: 2px solid #bbb;
}

.kpi-title {
}

.kpi-value {
    color: #009de0;
    font-size: 39px;
    font-weight: bold;
    border-bottom-style: dotted;
    border-width: 0 0 6px 0;
    border-color: #009de0;
}

.kpi-box:first-child .kpi-value {
    color: #f5f5f5;
}


</style>
